import axios from "axios";
import { BaseUrl } from "../helper/BaseUrl";

const ApiRequest = async (method, endpoint, payload = {}) => {
  const accessToken = localStorage.getItem("accessTokenBigbin");
  const config = {
    headers: {
      "x-access-token": accessToken,
    },
  };
  try {
    let response = null;
    switch (method) {
      case "POST":
        response = await axios.post(BaseUrl + endpoint, payload, config);
        break;

      case "GET":
        response = await axios.get(BaseUrl + endpoint, config);
        break;

      // case "PUT":
      //   response = await axios.put(BaseUrl + endpoint, payload, headers);
      //   break;

      case "DELETE":
        response = await axios.delete(BaseUrl + endpoint, { ...config, data: payload });
        break;

      default:
        throw new Error(`Invalid method: ${method}`);
    }
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default ApiRequest;
